import translator from '@/locales';

export default function email(
  message = translator.t('INVALID_INPUT_VALUE_EMAIL'),
) {
  return {
    type: 'email',
    message,
    trigger: 'blur',
  };
}
